export default function Arrowright(props){
    return(
        <svg width={props.width}  height={props.height}  viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
            {/* <title>Iconly/Light/Arrow - Right 2</title> */}
            <g id="Iconly/Light/Arrow---Right-2" stroke="currentColor"  stroke-width="3"  fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <g id="Arrow---Right-2" transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) translate(5.000000, 8.500000)" stroke="currentColor"  stroke-width="3" >
                    <polyline id="Stroke-1" points="14 0 7 7 0 0"></polyline>
                </g>
            </g>
        </svg>
    );
}